import React, { StrictMode } from 'react';
import { EnhancedStore } from '@reduxjs/toolkit';
import { connect, Provider } from 'react-redux';
import { HelmetContext, Helmet, Provider as HelmetProvider } from '@okapi/helmet-react';
import { RenderCallback } from '@okapi/core';
import { GlobalRouter, Router } from '@okapi/router-react';
import { Provider as RemoteProvider } from '@okapi/remote';
import { RootState } from 'store';
import { App } from 'app';
import { getEnv } from 'common/selectors/env';
import { YandexMetricaScript, GoogleAnalyticsScript } from 'features/analytics';

export type EntryProps = { router: GlobalRouter; remoteContext?: RenderCallback['remoteContext'] } & (
  | ClientSideEntryProps
  | ServerSideEntryProps
);

type ClientSideEntryProps = {
  helmetContext?: never;
  store: EnhancedStore;
};

type ServerSideEntryProps = {
  helmetContext?: HelmetContext;
  store: EnhancedStore;
};

const mapState = (state: RootState) => state;

const ConnectedApp = connect(mapState)(App);

export function createEntry({ store, router, helmetContext, remoteContext }: EntryProps) {
  return () => {
    const state = store.getState();
    const { ORCHESTRATOR_HOST = '' } = getEnv(state) || {};
    const orhestratorDomain = ORCHESTRATOR_HOST ? new URL(ORCHESTRATOR_HOST).origin : '';

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      /* @ts-ignore */
      <Router router={router}>
        <StrictMode>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
          {/* @ts-ignore */}
          <HelmetProvider context={helmetContext}>
            <Provider store={store}>
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
              {/* @ts-ignore */}
              <RemoteProvider context={remoteContext}>
                <ConnectedApp />
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                {/* @ts-ignore */}
                <Helmet>
                  <html lang="ru" />
                  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
                  <meta content="#444b5b" name="theme-color" />
                  <link href="//fonts.googleapis.com" rel="dns-prefetch" />
                  <link href="https://cdn.lemanapro.ru/" crossOrigin="anonymous" rel="preconnect" />
                  <link href="https://www.googletagmanager.com" crossOrigin="anonymous" rel="preconnect" />
                  <link href="https://www.google-analytics.com" crossOrigin="anonymous" rel="preconnect" />
                  <link href="https://fonts.gstatic.com" crossOrigin="anonymous" rel="preconnect" />
                  <link href={orhestratorDomain} crossOrigin="anonymous" rel="preconnect" />
                  <link
                    rel="preload"
                    href="https://static.lemanapro.ru/fronton/lm-main/demi-bold.woff2"
                    as="font"
                    crossOrigin="anonymous"
                  />

                  <link
                    rel="preload"
                    href="https://static.lemanapro.ru/fronton/lm-main/regular.woff2"
                    as="font"
                    crossOrigin="anonymous"
                  />
                  <link
                    href="https://static.lemanapro.ru/fronton/lm-fonts.css"
                    rel="preload"
                    as="style"
                    crossOrigin="anonymous"
                    onLoad={"this.rel = 'stylesheet'" as never}
                  />
                </Helmet>
                <YandexMetricaScript />
                <GoogleAnalyticsScript />
              </RemoteProvider>
            </Provider>
          </HelmetProvider>
        </StrictMode>
      </Router>
    );
  };
}
